import * as React from 'react';

function CloudStrikeThroughIconComponent(props: any) {
  return (
    <svg
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9998 7.11331C14.3565 7.48331 15.3332 8.72665 15.3332 10.1666C15.3332 11.37 14.6532 12.42 13.6598 12.9533L14.5198 13.8133L13.8132 14.52L1.47982 2.18665L2.18648 1.47998L4.74315 4.03331C5.54648 2.80998 6.92982 1.99998 8.49982 1.99998C10.9798 1.99998 12.9998 4.01998 12.9998 6.49998V7.11331ZM11.9998 6.49998C11.9998 4.56998 10.4298 2.99998 8.49982 2.99998C7.20315 2.99998 6.06982 3.70998 5.46648 4.75998L12.9065 12.1966C13.7365 11.8933 14.3332 11.0966 14.3332 10.1633C14.3332 9.07331 13.5165 8.15331 12.4365 8.01665L11.9998 7.96331V6.49998ZM1.66659 9.66669C1.66659 11.1367 2.86326 12.3334 4.33326 12.3334H10.2166L11.2166 13.3334H4.33659C2.31326 13.3334 0.669922 11.69 0.669922 9.66669C0.669922 7.78669 2.08992 6.24003 3.90992 6.02669L4.87992 7.00003H4.33326C2.86326 7.00003 1.66659 8.19669 1.66659 9.66669Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default CloudStrikeThroughIconComponent;
